import React, { useState, useEffect, useCallback } from "react";
import PersonalInfoInvited from "./PersonalInfo";
import JobS from "./Employement";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import "../ParentComponent/ParentComponent.scss";
import {
  ExperimentOutlined,
  SolutionOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import Reporting from "./ReportingInv";
import Skills from "./SkillsInv";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

function HumanResourceInv() {
  const [currentPage, setCurrentPage] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { employeeId } = useParams();
  const [imageFile, setImageFile] = useState(null);

  const navigate = useNavigate();

  // Centralized state to store all form data from each step
  const [allFormData, setAllFormData] = useState({
    step1: {}, // Personal info
    step2: {}, // Employment details
    step3: {}, // Reporting structure
    step4: {}, // Skills
  });

  const updateStepData = useCallback((stepNumber, data) => {
  if (stepNumber === 1 && data.image instanceof File) {
    setImageFile(data.image); //  SAVE REAL FILE
  }

  setAllFormData((prev) => ({
    ...prev,
    [`step${stepNumber}`]: {
      ...data,
    },
  }));
}, []);

const submitAllData = useCallback(async (finalStepData) => {
  if (isSubmitting) return;
  setIsSubmitting(true);

  try {
    const params = new URLSearchParams();
    
    // --- Step 1 & 2 Data ---
    params.append("EmployeeId", employeeId ? Number(employeeId) : 0);
    params.append("FirstName", allFormData.step1.firstName || "");
    params.append("LastName", allFormData.step1.lastName || "");
    params.append("Mobileno", allFormData.step1.mobileNo || "");
    params.append("Gender", allFormData.step1.gender || "");
    params.append("MaritalStatus", allFormData.step1.maritalStatus || "");
    params.append("StreetAddress", allFormData.step1.streetAddress || "");
    params.append("City", allFormData.step1.city || "");
    params.append("State", allFormData.step1.state || "");
    params.append("PostalCode", allFormData.step1.postalCode || "");
    params.append("Country", allFormData.step1.country || "");

    params.append("HiredDate", allFormData.step2.hiredDate || new Date().toISOString().split('T')[0]);
    params.append("ProbationStartDate", allFormData.step2.probationStartDate || "");
    params.append("ProbationEndDate", allFormData.step2.probationEndDate || "");
    params.append("PayType", Number(allFormData.step2.payType || 0));
    params.append("PriorExperienceYears", parseFloat(allFormData.step2.priorExperience || 0));
    params.append("BaseSalary", Number(allFormData.step2.baseSalary || 0));
    params.append("DesignationId", allFormData.step2.designationId || 0);
    params.append("EmploymentType", Number(allFormData.step2.employmentType ?? 0));
    params.append(
      "WorkAuthorizationStatus",
      Number(allFormData.step2.workAuthorizationStatus ?? 0)
    );
    params.append("SponsorshipNeeded", allFormData.step2.sponsorshipNeeded === true);
    
if (allFormData.step2.departmentId && allFormData.step2.departmentId > 0) {
    params.append("DepartmentId", Number(allFormData.step2.departmentId));
}

if (allFormData.step2.jobTitleId && allFormData.step2.jobTitleId > 0) {
    params.append("JobTitleId", Number(allFormData.step2.jobTitleId));
}

    // --- Step 3: Reporting Fix ---
    // Note: Reporting.js returns { selectedSupervisor: { id: ... }, placementOption: "..." }
    const supervisorId = allFormData.step3.selectedSupervisor?.id;
    
    // Crucial: Only append if it's a real ID. Do not send 0.
    if (supervisorId && Number(supervisorId) > 0) {
      params.append("SupervisorId", Number(supervisorId));
    }

    // Logic: "PARENT" means the new employee takes over existing reports
    const shouldReassign = allFormData.step3.placementOption === "PARENT";
    params.append("ReassignDirectReports", shouldReassign);

    // --- Step 4: Skills and domains---

 const domainIds = finalStepData?.domainIds || [];
    const skillIds = finalStepData?.skillIds || [];
    const customSkills = finalStepData?.customSkills || [];

    domainIds.forEach(id => params.append("DomainKnowledgeIds",id));
    skillIds.forEach(id => params.append("SkillIds", id));
    customSkills.forEach(skill => params.append("CustomSkills", skill));

    // --- Prepare the Body (Image) ---
    const bodyFormData = new FormData();
    if (imageFile instanceof File) {
      bodyFormData.append("Image", imageFile);
    }

   const response = await axiosInstance.post(
      `${API.employee.createInvite}?${params.toString()}`, 
      bodyFormData 
    );

    message.success("Employee created successfully ");
    localStorage.removeItem("employeeFormData");
    navigate("/organization/directory");
  } catch (error) {
    console.error("BACKEND ERROR 👉", error.response?.data);
    message.error(error.response?.data?.details || "Failed to create employee ❌");
  } finally {
    setIsSubmitting(false);
  }
}, [allFormData, employeeId, imageFile, navigate, isSubmitting]);

  // Navigate to next step and store current step data
  const handleNextPage = useCallback( (stepData) => {
    updateStepData(currentPage, stepData);

    //  Step 2 → Check rank
    if (currentPage === 2) {
      const rank = stepData.designationRank;

      if (rank === 1) {
        // Clear reporting step
        setAllFormData((prev) => ({
          ...prev,
          step3: {},
        }));

        // Skip to Step 4
        setCurrentPage(4);
        return;
      }
    }

    //  Final Step Submit
    if (currentPage === 4) {
      submitAllData(stepData);
    } else {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  },
  [currentPage, updateStepData, submitAllData]
);

  const handlePreviousPage = useCallback(() => {
    setCurrentPage((prevPage) => prevPage - 1);
  }, []);

  // Save form data to localStorage for persistence
  useEffect(() => {
    localStorage.setItem("employeeFormData", JSON.stringify(allFormData));
  }, [allFormData]);

  // Load form data from localStorage on mount
  useEffect(() => {
    const savedData = localStorage.getItem("employeeFormData");
    if (savedData) {
      try {
        setAllFormData(JSON.parse(savedData));
      } catch (error) {
        console.error("Error parsing saved form data:", error);
      }
    }
  }, []);

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <div className="stepper-wrapper">
            <div className={`stepper-item initial ${currentPage >= 1 ? "completed" : ""}`}>
              <div className={`step-counter ${currentPage === 1 ? "active" : ""}`}>
                <UserOutlined />
              </div>
              <div className="step-name">Personal</div>
            </div>
            <div className={`stepper-item ${currentPage >= 2 ? "completed" : ""}`}>
              <div className={`step-counter ${currentPage === 2 ? "active" : ""}`}>
                <SolutionOutlined />
              </div>
              <div className="step-name">Employment</div>
            </div>
            <div className={`stepper-item ${currentPage >= 3 ? "completed" : ""}`}>
              <div className={`step-counter ${currentPage === 3 ? "active" : ""}`}>
                <TeamOutlined />
              </div>
              <div className="step-name">Reporting</div>
            </div>
            <div className={`stepper-item ${currentPage >= 4 ? "completed" : ""}`}>
              <div className={`step-counter ${currentPage === 4 ? "active" : ""}`}>
                <ExperimentOutlined />
              </div>
              <div className="step-name">Skills</div>
            </div>
          </div>

          {currentPage === 1 && (
            <PersonalInfoInvited onNext={handleNextPage} initialData={allFormData.step1} />
          )}

          {currentPage === 2 && (
            <JobS
              onNext={handleNextPage}
              onBack={handlePreviousPage}
              initialData={allFormData.step2}
              jobData={allFormData.step1} // Pass the data from Personal step which includes departmentId
            />
          )}

          {currentPage === 3 && (
            <Reporting
              onNext={handleNextPage}
              onBack={handlePreviousPage}
              initialData={allFormData.step3}
              jobData={{
                ...allFormData.step1, // departmentId, fullName
                ...allFormData.step2, // designationId, designationName
              }}
            />
          )}

          {currentPage === 4 && (
            <Skills
  onNext={handleNextPage}
  onBack={handlePreviousPage}
  initialData={allFormData.step4}
  isSubmitting={isSubmitting}
  departmentId={allFormData.step2.departmentId || allFormData.step1.departmentId}
/>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default HumanResourceInv;
